import {Injectable} from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpHeaders,
  HttpClient,
  HttpErrorResponse,
} from '@angular/common/http';
import {environment} from 'src/environments/environment';
import {Router} from '@angular/router';
import {Observable, throwError} from 'rxjs';
import {catchError, timeout} from 'rxjs/operators';
import {MatSnackBar, MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition} from '@angular/material/snack-bar';
import {ActivatedRoute} from '@angular/router';
import {NetworkStatusService} from "../network-status/network-status.service";


@Injectable({
  providedIn: 'root',
})
export class RxAuthService {
  permission_list: Array<number> = [];
  isStaff: boolean | null = null;
  token: any = localStorage.getItem('jwt_access');
  httpOptions: any = {
    headers: this.setTokenHeader(this.token),
    responseType: 'json',
  };

  constructor(private http: HttpClient, private router: Router, private snack: MatSnackBar, private route: ActivatedRoute) {
  }

  rx_login(token: any, wp: boolean = false) {
    console.log('Auth Service');
    let url = ''
    if (wp) {
      url = `${environment.backend_base}wp/angular_login/`;
    } else {
      url = `${environment.backend_base}main/auth/rx-login/`;
    }


    let payload = {
      rxToken: token,
    };
    // console.log(url)
    // console.log(payload)
    this.http.post(url, payload).subscribe((response: any) => {
      if (response.status === 'success') {
        this.token = response.token;
        localStorage.setItem('token', response.token);

        localStorage.setItem('jwt_refresh', response.jwt.refresh);
        localStorage.setItem('jwt_access', response.jwt.access);
        localStorage.setItem('isStaff', response.is_staff)
        localStorage.setItem('permissions', response.permissions)
        // console.log(response.permissions)
        localStorage.setItem('username', response.username)

        this.isStaff = response.is_staff

        const forwardURL = localStorage.getItem('forwardURL');

        let cookie_list = response.cookies.map((i: any) => i.name)

        localStorage.setItem('cookies', cookie_list)
        this.permission_list = [...response.permissions];

        let params: any = ''
        this.route.queryParams.subscribe((tempParams: any) => {
          params = tempParams
        })
        /*
        this.resetUserVerificationToken(token, undefined).subscribe({
          next: (resetResponse) => {
            console.log('Verification token reset successfully:');
          },
          error: (error) => {
            console.error('Failed to reset verification token:', error);
          },
        });*/

        if (!forwardURL) {
          if (Object.keys(params).length > 1) {
            let targetUrl = `${params.view.replaceAll('_', '/')}?`
            // console.log("targetUrl=" + targetUrl)
            Object.entries(params).forEach((entry: any, index: number) => {

              if (index > 0 && entry[0] !== 'rx_token') { //Skip token and url
                if (index % 2 !== 0) {
                  targetUrl += `&${entry[1]}`
                } else {
                  targetUrl += `=${entry[1]}`
                }
              }
            })


            window.location.href = environment.frontend_base + targetUrl
            //this.router.navigateByUrl(targetUrl)
          } else {
            this.router.navigateByUrl('/landing');
          }

        } else if (forwardURL) {
          localStorage.removeItem('forwardURL');
          window.location.href = forwardURL;

        }

      }
    });
  }

  clearAllStorages(): void {
    localStorage.clear();
    sessionStorage.clear();
    console.log('Local && Session storages cleared');
  }

  // Get the HTTP headers with the Authorization token
  setTokenHeader(token: string | null): HttpHeaders {
    if (token !== null) {
      return new HttpHeaders({
        'Content-type': 'application/json',
        'ngrok-skip-browser-warning': 'yes',
        Authorization: `Bearer ${token}`,
      });
    } else {
      return new HttpHeaders({
        'Content-Type': 'application/json',
        'ngrok-skip-browser-warning': 'yes',
      });
    }
  }

  isBasicUser() {
    //if (localStorage.getItem('permissions')?.indexOf('1') !== -1 || localStorage.getItem('permissions')?.indexOf('5') !== -1) {
    if (localStorage.getItem('permissions')) {
      return true
    } else {
      return false
    }
  }

  isPremiumUser() {
    if (localStorage.getItem('permissions')?.indexOf('2') !== -1 || localStorage.getItem('permissions')?.indexOf('7') !== -1) {
      return true
    } else {
      return false
    }
  }

  isStaffUser() {
    if (localStorage.getItem('permissions')?.indexOf('3') !== -1 || localStorage.getItem('permissions')?.indexOf('8') !== -1 || localStorage.getItem('isStaff') === "true") {
      return true
    } else {
      return false
    }
  }

  isLBBasicUser() {
    if (localStorage.getItem('permissions')?.indexOf('4') !== -1) {
      //Always returns true, as lb is accessible by all registered users
      return true
    } else {
      return true
    }

  }

  removeWpTokenParam(params: any): any {
    const updatedParams = {...params};
    delete updatedParams['wp_token']; // Remove wp_token from the parameters
    return updatedParams;
  }

  resetUserVerificationToken(
    verification_token: string | undefined,
    user_id: number | undefined
  ): Observable<any> {
    const url = `${environment.backend_base}wp/reset-user-verification-token/`;

    // Dynamically construct the body based on input parameters
    const body: { verification_token?: string; user_id?: number } = {};
    if (verification_token) {
      body.verification_token = verification_token;
    }
    if (user_id) {
      body.user_id = user_id;
    }

    return this.http.post<any>(url, body, this.httpOptions);
  }

  isEssentialUser() {
    if (localStorage.getItem('permissions')?.indexOf('6') !== -1) {
      return true
    } else {
      return false
    }
  }

  /*
     isBasicUser() {

         return true

     }

     isEssentialUser() {

       return false

   }

     isPremiumUser() {

         return false
     }

     isStaffUser() {

         return false

     }
     isLBBasicUser() {

         return true

     }
 */


}
export function isLoggedIn(): boolean {
  const token = localStorage.getItem('jwt_access');
  return !!token; // returns true if token exists and is not an empty string
}

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  private hasTriggeredReSignIn = false;

  constructor(private router: Router,
              private auth: RxAuthService,
              private snack: MatSnackBar,
              private route: ActivatedRoute,
              private networkStatus: NetworkStatusService
  ) {
  }

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // Check if the request has the custom header 'Skip-Auth'
    if (req.headers.has('Skip-Auth')) {
      // Clone the request to remove the 'Skip-Auth' header
      const clonedReq = req.clone({
        headers: req.headers.delete('Skip-Auth'),
      });
      return next.handle(clonedReq);
    }

    // Check current params for WP token and trigger re-sign-in if applicable
    this.route.queryParams.subscribe((params: any) => {
      if (
        !this.hasTriggeredReSignIn && // Ensure it hasn't been triggered already
        Object.keys(params).length > 0 &&
        'wp_token' in params
      ) {
        const wpToken = params['wp_token']; // Store the token in a constant

        const updatedParams = this.auth.removeWpTokenParam(params)


        this.hasTriggeredReSignIn = true; // Set the flag to prevent re-triggering
        this.auth.rx_login(wpToken, true); // Trigger the re-sign-in

        // TODO: FIX THIS
        const currentPath = this.router.url.split('?')[0].replace(/^\/+/, ''); // Remove leading slash if necessary
        const updatedQueryString = new URLSearchParams(updatedParams).toString();

        const updatedRoute = updatedQueryString.length > 0
          ? `${environment.frontend_base}${currentPath}?${updatedQueryString}`
          : `${environment.frontend_base}${currentPath}`;

        localStorage.setItem('forwardURL', updatedRoute);

        localStorage.setItem('updatedRoute', updatedRoute);
        localStorage.setItem('updatedRoute', updatedRoute);
      }
    });


    // Get the auth token from localStorage
    const authToken = localStorage.getItem('jwt_access');

    // Extract the current path from the request URL
    const urlParts = new URL(req.url, window.location.origin).pathname.split(
      '/'
    );
    const currentPath = '/' + urlParts.slice(-4).join('/');


    // Check if authToken is missing or the current path is not '/'
    /*
    if (
      !authToken && currentPath !== '/main/auth/rx-login/'
    ) {
      // Redirect to the chosen URL if no token is present or path is not '/'
      window.location.href = environment.raa.frontend_base;
      // Optionally, you can return an observable that completes immediately
      return throwError(() => new Error('No auth token found or path is not /'));
    }*/

    // Clone the request and set the new header in one step
    const authReq = req.clone({
      setHeaders: {
        Authorization: `Bearer ${authToken}`,
      },
    });

    // Send cloned request with header to the next handler
    return next.handle(authReq).pipe(
      catchError((error: HttpErrorResponse) => {
          console.log('Error', error);
        if (error.status === 0) {
          // Possibly offline or CORS/network issue
          this.networkStatus.isOnline$.next(false);
        }
          if (error.status === 401 && !this.hasTriggeredReSignIn) {
            this.networkStatus.isOnline$.next(true); // still online, just unauthorized
            this.auth.clearAllStorages();
            // Redirect to the chosen URL on 401 Unauthorized response
            let baseUrl = window.location.href
              .split('//')[1]
              .split('?')[0]
              .replaceAll('/', '_');
            let paramsToSend: any = {};
            this.route.queryParams.subscribe((params: any) => {
              paramsToSend = params;
            });

            let paramsString = '';
            Object.entries(paramsToSend).forEach(
              (item: any, index: number) =>
                (paramsString = `${paramsString}&key${index}=${item[0]}&value${index}=${item[1]}`)
            );

            // let url = encodeURI(
            //   environment.raa.frontend_base +
            //     'login?url=' +
            //     baseUrl +
            //     paramsString
            // );
            //
            // window.location.href = url; // Redirect to the login page.

            this.router.navigate(['/rxlogin']);  // TODO: To be changed to add params in when needed
          }
          else if (error.status === 403) {
            this.networkStatus.isOnline$.next(true); // forbidden, but online
            let errorMessage =
              "Sorry, you're not allowed to access this resource. Redirecting to RetailX Intelligence Home";
            this.snack.open(errorMessage, 'Close', {
              horizontalPosition: 'center',
              verticalPosition: 'top',
            });

            setTimeout(() => {
              window.location.href = environment.wp.frontend_base;
            }, 4000);
          }
          else if (error.status === 404 || error.status === 400) {
            this.networkStatus.isOnline$.next(true); // still online, just not found or bad request
            // Allow 404 and 400 errors to pass through
            console.error('Error occurred:', error); // Log the error to the console
            if (!this.auth.isStaffUser()) {
              // Check if the user is NOT a staff member
              //this.router.navigate(['/capacity-reached']);
            }
            return throwError(() => error); // Throw the error to propagate it
          }

          // Log the error for other statuses
          console.error('Error occurred:', error); // Log the error to the console
          if (!this.auth.isStaffUser()) {
            // Check if the user is NOT a staff member
            this.router.navigate(['/capacity-reached']);
          }
          // fallback
          this.networkStatus.isOnline$.next(true);
          return throwError(() => new Error('error in rx-auth interceptor')); // Throw a new error
        }
      )
    );
  }
}
